// extracted by mini-css-extract-plugin
module.exports = {"container":"bf","disabled":"cf","bgBlack":"df","content":"ef","countdown":"ff","topCaption":"gf","topHeading":"hf","heading":"if","copy":"jf"};